import type { MatasPlusOfferDisclaimerQuickViewModel, PageActionMaybe } from 'autogen/swagger/all';
import useMediatorState, { mediatorAtom } from 'hooks/globals/useMediatorAtom';

export const PlusOfferNudgeQuickViewAtom = mediatorAtom<{
    isOpen: boolean;
    model?: MatasPlusOfferDisclaimerQuickViewModel;
    allowSignUp?: boolean;
    pageAction?: PageActionMaybe;
}>({
    isOpen: false
});

export default function usePlusOfferNudgeQuickView() {
    return useMediatorState(PlusOfferNudgeQuickViewAtom);
}
